document.addEventListener('DOMContentLoaded', function () {
  var selectedOption = ''; // Store the selected customization option (DTF/Embroidery)
  var productHandle = '';
  var productTitle = '';
  var customImageURL = ''; // Store URL of the uploaded image
  var imageFile = null; // Store the image file
  var fetchAttempts = 0; // Counter for fetch attempts
  var maxFetchAttempts = 3; // Maximum number of fetch retries
  var MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes

  // Mapping of tags to placement image URLs
  const tagImageMap = {
    'Tshirt': 'https://cdn.shopify.com/s/files/1/0821/6058/2942/files/Placement-TShirt.jpg?v=1728263953',
    'Fleece': 'https://cdn.shopify.com/s/files/1/0821/6058/2942/files/Placement-Fleece.jpg?v=1728263953',
    'Headwear': 'https://cdn.shopify.com/s/files/1/0821/6058/2942/files/Placement-Cap.jpg?v=1728263951'
  };

  // Get the product handle from the URL query parameter
  var urlParams = new URLSearchParams(window.location.search);
  productHandle = urlParams.get('product');

  // Function to construct the correct image URL
  function constructImageUrl(url) {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      // Absolute URL, use as is
      return url;
    } else if (url.startsWith('//')) {
      // Protocol-relative URL, prepend the current protocol (https:)
      return window.location.protocol + url;
    } else if (url.startsWith('/')) {
      // Relative URL, prepend the shop's origin
      return window.location.origin + url;
    } else {
      // Other relative paths, adjust as needed
      return window.location.origin + '/' + url;
    }
  }

  // Function to fetch product data with retry logic
  function fetchProductData(handle) {
    fetchAttempts++;
    console.log(`Fetching product data (Attempt ${fetchAttempts}) for handle: ${handle}`);

    fetch('/products/' + handle + '.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok (Status: ${response.status})`);
        }
        return response.json();
      })
      .then(product => {
        productTitle = product.title; // Store product title for later use
        document.getElementById('product-title').innerText = 'Customize: ' + productTitle;
        console.log('Product data fetched successfully:', product);

        // Display the first product image
        if (product.images && product.images.length > 0) {
          var firstImageUrl = product.images[0]; // Assuming the first image is desired
          var imageUrl = constructImageUrl(firstImageUrl);
          console.log('Constructed image URL:', imageUrl);
          var productImage = document.getElementById('product-image');

          // Verify that the image element exists
          if (productImage) {
            var productImageContainer = document.getElementById('product-image-container');
            if (productImageContainer) {
              productImageContainer.style.display = 'block'; // Show the container
            } else {
              console.error('Product image container element not found in the DOM.');
            }

            productImage.src = imageUrl;
            productImage.style.display = 'block'; // Show the image

            // Optional: Handle image loading errors
            productImage.onerror = function () {
              console.error('Failed to load product image:', imageUrl);
              productImage.style.display = 'none';
              alert('Failed to load product image. Please try again.');
            };
          } else {
            console.error('Product image element not found in the DOM.');
          }
        } else {
          console.warn('No images found for this product.');
        }

        

        // **Display Placement Images Based on Tags**
        displayPlacementImages(product.tags);
        if (product.tags.some(tag => tag.toLowerCase().trim() === 'headwear')) {
        var dtfButton = document.getElementById('dtf-button');
        if (dtfButton) {
          dtfButton.disabled = true; // Disable the DTF button
          dtfButton.classList.add('disabled'); // Optional: Add a CSS class for styling disabled state
          console.log('DTF option disabled because the product tag includes "Headwear".');
        } else {
          console.warn('DTF button not found in the DOM.');
        }
      }
        // **Step 1: Fetch Cart Data and Handle Product Count**
        fetchCartDataAndHandleCount();
      })
      .catch(error => {
        console.error(`Error fetching product data (Attempt ${fetchAttempts}):`, error);
        if (fetchAttempts < maxFetchAttempts) {
          console.log('Retrying to fetch product data...');
          setTimeout(() => fetchProductData(handle), 2000); // Retry after 2 seconds
        } else {
          document.getElementById('product-title').innerText = 'Product not found';
          alert('Unable to fetch product data after multiple attempts. Please try again later.');
        }
      });
  }

  // Function to display placement images based on tags
  function displayPlacementImages(tags) {
    if (!tags || tags.length === 0) {
      console.warn('No tags provided for placement image determination.');
      return;
    }

    var placementContainer = document.getElementById('placement-images');
    if (!placementContainer) {
      console.error('Placement images container not found in the DOM.');
      return;
    }

    // Show the placement wrap card
    var placementWrap = document.getElementById('placement-images-wrap');
    if (placementWrap) placementWrap.style.display = 'block';

    // Clear any existing images
    placementContainer.innerHTML = '';

    // Iterate through the tags and display corresponding images
    tags.forEach(function(tag) {
      // Normalize tag for case-insensitive comparison
      var normalizedTag = tag.trim().toLowerCase();

      // Check if the tag matches any key in the tagImageMap
      for (var key in tagImageMap) {
        if (tagImageMap.hasOwnProperty(key)) {
          if (normalizedTag === key.toLowerCase()) {
            // Get the image URL from the map
            var imageUrl = tagImageMap[key];

            // Create an image element
            var imgElement = document.createElement('img');
            imgElement.src = imageUrl;
            imgElement.alt = key + ' Placement';
            imgElement.title = key + ' Placement';

            // Append the image to the container
            placementContainer.appendChild(imgElement);

            console.log(`Displayed placement image for tag: ${key}`);
            break; // Stop checking other keys once a match is found
          }
        }
      }
    });

    // If no matching tags found, optionally display a default image or message
    if (placementContainer.innerHTML === '') {
      console.log('No matching tags found for placement images.');
      placementContainer.innerHTML = '<p>No placement images available for this product.</p>';
    }
  }

  // Function to fetch cart data and handle the product count
  function fetchCartDataAndHandleCount() {
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart data (Status: ${response.status})`);
        }
        return response.json();
      })
      .then(cart => {
        console.log('Current cart data:', cart);

        // Find all cart items matching the product handle
        var matchingItems = cart.items.filter(item => item.handle === productHandle);

        // Calculate the total quantity of the current product in the cart
        var totalQuantity = matchingItems.reduce((acc, item) => acc + item.quantity, 0);

        // Update the product count on the page
        var productCountElement = document.getElementById('product-count');
        if (productCountElement) {
          productCountElement.innerText = totalQuantity === 1 ? '1 item in cart' : `${totalQuantity} items in cart`;
        } else {
          console.error('Product count element not found in the DOM.');
        }

        if (totalQuantity === 0) {
          alert('You have no units of this product in your cart. Closing this tab and returning to the previous page.');

          // Attempt to refresh the opener (referring) tab
          if (window.opener && !window.opener.closed) {
            window.opener.location.reload();
          }

          // Attempt to close the current tab
          window.close();

          // Show the Close Tab button as a fallback
          showCloseTabButton();
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
        alert('Unable to fetch cart data. Please try again later.');
      });
  }

  if (productHandle) {
    // Start fetching product data
    fetchProductData(productHandle);
  } else {
    document.getElementById('product-title').innerText = 'No product handle provided';
    alert('No product handle found in the URL. Closing this tab and returning to the previous page.');

    // Attempt to refresh the opener (referring) tab
    if (window.opener && !window.opener.closed) {
      window.opener.location.reload();
    }

    // Attempt to close the current tab
    window.close();

    // Show the Close Tab button as a fallback
    showCloseTabButton();
  }

  // Show the text field and the done button when an option is selected
  function showTextField() {
    var subOptionDiv = document.getElementById('sub-option');
    subOptionDiv.style.display = 'block'; // Show the text field and the done button
    document.getElementById('done-button').style.display = 'inline-block';

    // Handle character count update
    var textField = document.getElementById('custom-text');
    var charCount = document.getElementById('char-count');

    // Remove any existing event listeners to prevent multiple bindings
    textField.removeEventListener('input', updateCharCount);
    textField.addEventListener('input', updateCharCount);

    function updateCharCount() {
      var currentLength = textField.value.length;
      charCount.innerText = currentLength + ' / 60';
    }

    // Initialize character count
    updateCharCount();
  }

  // Function to highlight the selected button
  function highlightSelectedButton(selectedButton) {
    // Get all customization buttons
    var buttons = document.querySelectorAll('#dtf-button, #embroidery-button');
    buttons.forEach(function(button) {
      button.classList.remove('selected'); // Remove highlight from all
    });
    selectedButton.classList.add('selected'); // Highlight the selected button
  }

  // Handle DTF button click
  var dtfButton = document.getElementById('dtf-button');
  if (dtfButton) {
    dtfButton.addEventListener('click', function () {
      selectedOption = 'DTF'; // Store the selected option
      showTextField();
      highlightSelectedButton(this); // Highlight this button
      console.log('DTF option selected');
    });
  } else {
    console.error('DTF button not found in the DOM.');
  }

  // Handle Embroidery button click
  var embroideryButton = document.getElementById('embroidery-button');
  if (embroideryButton) {
    embroideryButton.addEventListener('click', function () {
      selectedOption = 'Embroidery'; // Store the selected option
      showTextField();
      highlightSelectedButton(this); // Highlight this button
      console.log('Embroidery option selected');
    });
  } else {
    console.error('Embroidery button not found in the DOM.');
  }

  // Store the image file when selected, but do not upload yet
  var customImageInput = document.getElementById('custom-image');
  if (customImageInput) {
    customImageInput.addEventListener('change', function () {
      var file = this.files[0];
      var imageNameSpan = document.getElementById('image-name');

      if (file) {
        // Check the file size
        if (file.size > MAX_IMAGE_SIZE) {
          alert('Image size exceeds 5 MB. Please select a smaller image.');
          this.value = ''; // Reset the input
          imageNameSpan.innerText = 'Click to upload or drag & drop';
          imageFile = null;
          console.log('Selected image exceeds size limit and was not accepted.');
        } else {
          imageFile = file;
          imageNameSpan.innerText = file.name;
          console.log('Image selected:', file.name);
        }
      } else {
        imageNameSpan.innerText = 'Click to upload or drag & drop';
        imageFile = null;
        console.log('No image selected');
      }
    });
  } else {
    console.error('Custom image input element not found in the DOM.');
  }

  function uploadImageToFastAPI() {
  const UPLOAD_PROXY_URLS = [
    'https://fastapi-example-23ax.onrender.com/upload-image/',
    'http://testing.aayushpathak.com/upload-image/' // Replace with your actual fallback URL
  ];
  
  const formData = new FormData();
  formData.append('file', imageFile);
  console.log('Uploading image to FastAPI:', imageFile.name);

  // Function to try uploading to a specific URL
  const tryUpload = (urlIndex) => {
    if (urlIndex >= UPLOAD_PROXY_URLS.length) {
      throw new Error('Image upload failed: All proxy URLs failed.');
    }

    const url = UPLOAD_PROXY_URLS[urlIndex];
    console.log(`Trying to upload to: ${url}`);

    return fetch(url, {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok (Status: ${response.status})`);
        }
        return response.json();
      })
      .then(data => {
        if (data.download_url) { // Assuming FastAPI returns { "download_url": "..." }
          console.log('Image uploaded successfully. Download URL:', data.download_url);
          return data.download_url;
        } else {
          throw new Error('Image upload failed: No download URL returned.');
        }
      })
      .catch(error => {
        console.error(`Error uploading image to ${url}:`, error);
        console.log('Attempting to use the next proxy URL...');
        return tryUpload(urlIndex + 1); // Try the next URL in the list
      });
  };

  // Start the upload process with the first URL
  return tryUpload(0);
}


  // Function to update one cart item using the key instead of id
  function updateCartItem(itemKey, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey, // Use the key to update the specific line item
        quantity: quantity, // Maintain the quantity
        properties: properties // Add or update properties
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to update cart item (Status: ${response.status})`);
      }
      return response.json();
    })
    .then(updatedCart => {
      console.log('Cart updated successfully:', updatedCart);
      return updatedCart;
    })
    .catch(error => {
      console.error('Error updating cart item:', error);
      throw error;
    });
  }

  // Show loader
  function showLoader() {
    var loader = document.getElementById('loader');
    if (loader) {
      loader.style.display = 'block';
    } else {
      console.warn('Loader element not found in the DOM.');
    }
  }

  // Hide loader
  function hideLoader() {
    var loader = document.getElementById('loader');
    if (loader) {
      loader.style.display = 'none';
    } else {
      console.warn('Loader element not found in the DOM.');
    }
  }

  // Function to show the Close Tab button
  function showCloseTabButton() {
    var closeTabContainer = document.getElementById('close-tab-container');
    if (closeTabContainer) {
      closeTabContainer.style.display = 'block';
    } else {
      console.error('Close tab container element not found in the DOM.');
    }

    var closeTabButton = document.getElementById('close-tab-button');
    if (closeTabButton) {
      closeTabButton.addEventListener('click', function () {
        // Attempt to refresh the opener tab
        if (window.opener && !window.opener.closed) {
          window.opener.location.reload();
        }

        // Attempt to close the current tab
        window.close();

        // Fallback alert
        setTimeout(function () {
          alert('Please close this tab manually.');
        }, 1000);
      });
    } else {
      console.error('Close tab button not found in the DOM.');
    }
  }

  // Handle Done button click to upload the image and update cart line item properties
  var doneButton = document.getElementById('done-button');
  if (doneButton) {
    doneButton.addEventListener('click', function () {
      var customText = document.getElementById('custom-text').value.trim();

      if (!selectedOption || !customText) { // Removed imageFile from the required fields
        alert('Please select an option and enter a customization.');
        return;
      }

      // Show the loader while processing
      showLoader();

      console.log('Processing customization with:', {
        selectedOption: selectedOption,
        customText: customText,
        imageFile: imageFile ? imageFile.name : 'No image uploaded'
      });

      // Step 1: Fetch the current cart
      fetch('/cart.js')
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to fetch cart data (Status: ${response.status})`);
          }
          return response.json();
        })
        .then(cart => {
          console.log('Current cart data:', cart);

          // Find all cart items matching the product handle
          var matchingItems = cart.items.filter(item => item.handle === productHandle);

          if (matchingItems.length === 0) {
            alert('No matching items found in the cart. Customization cannot be applied.');
            hideLoader(); // Hide the loader if no items found
            return;
          }

          console.log(`Found ${matchingItems.length} matching item(s) in the cart.`);

          // Function to process customization after verifying matching items
          function processCustomization(uploadedImageURL) {
            // Define the function to process each matching cart item one by one
            function updateNextItem(index) {
              if (index >= matchingItems.length) {
                // Hide the loader once all updates are done
                hideLoader();

                // Warn the user that the tab will close
                alert('All matching items updated with customization. The current tab will close, and the previous tab will refresh.');

                // Try closing the window
                setTimeout(function () {
                  // Attempt to refresh the referring tab by updating its location
                  if (window.opener && !window.opener.closed) {
                    window.opener.location.reload();
                  }

                  // Attempt to close the current tab
                  window.close();

                  // Fallback in case window.close() doesn't work
                  setTimeout(function () {
                    alert('Please close this tab manually.');
                    // Show the Close Tab button as a final fallback
                    showCloseTabButton();
                  }, 1000);
                }, 1000); // Delay to allow user to see the final message
                return;
              }

              var currentItem = matchingItems[index];
              console.log(`Updating cart item ${index + 1}/${matchingItems.length}:`, currentItem);

              // Prepare properties to update
              var newProperties = {
                'Customization Option': selectedOption,
                'Customization Text': customText
              };

              if (uploadedImageURL) { // Only add image URL if it exists
                newProperties['Customization Image URL'] = uploadedImageURL;
              }

              // Update the cart item properties using the key
              updateCartItem(currentItem.key, currentItem.quantity, {
                ...currentItem.properties,
                ...newProperties
              }).then(() => {
                // Wait for the cart to be updated, then reload and update the next item
                setTimeout(function () {
                  // Recursively call the next update
                  updateNextItem(index + 1);
                }, 500); // Delay to ensure proper sequential updates
              }).catch(error => {
                alert('Error updating cart item: ' + error.message);
                hideLoader(); // Hide the loader if there's an error
              });
            }

            // Start the update process
            updateNextItem(0);
          }

          // Step 2: Check if an image is uploaded
          if (imageFile) {
            // Step 3: Upload the image since matching items exist
            uploadImageToFastAPI()
              .then(uploadedFileURL => {
                customImageURL = uploadedFileURL; // Store the URL returned by the FastAPI server
                processCustomization(customImageURL);
              })
              .catch(error => {
                alert('Error uploading image: ' + error.message);
                hideLoader(); // Hide the loader if there's an error
              });
          } else {
            // No image uploaded, proceed without uploading
            processCustomization(null);
          }
        })
        .catch(error => {
          alert('Error processing customization: ' + error.message);
          hideLoader(); // Hide the loader if there's an error
        });
    });
  } else {
    console.error('Done button not found in the DOM.');
  }
});
